import { render, staticRenderFns } from "./bankHolidays.vue?vue&type=template&id=9dab19fa"
import script from "./bankHolidays.vue?vue&type=script&lang=js"
export * from "./bankHolidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports